// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify(
  {
    theme: {
      defaultTheme: 'customTheme',
      themes: {
        customTheme: {
          dark: false,
          colors: {
            primary: '#1976D2',
            secondary: '#424242',
          },
        },
      },
    },
    locale: {
    locale: 'en',
    fallback: 'en',
    rtl: { fa: true, en: true, },
  },
  }
)
